export default __webpack_public_path__ + "static/media/Chevron_Down.c6f34f8f.svg";